import styled from "@emotion/styled";

import {
  COLOR_ATHENS_GRAY_DARKER_2,
  COLOR_BLUE_RIBBON,
  COLOR_DOWNRIVER,
  COLOR_LINK_WATER,
  COLOR_PICKLE_BLUEWOOD,
  COLOR_SHUTTLE_GRAY,
} from "../../constants/styles";

import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";

const entrataTableCellSX = { color: `${COLOR_SHUTTLE_GRAY} !important`, justifyContent: 'center' };
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid lightgray;
  padding-top: 8px;
  margin-top: 8px;
`;
const DividerVertical = styled.div`
  display: flex;
  height: 30px;
  width: 1px;
  background-color: lightgray;
`;


export const IntegrationTableEntrataHead = () => (
  <TableHead>
    <TableRow>
      <TableCell colSpan={2} sx={{ bgcolor: COLOR_BLUE_RIBBON }}>RoomSync</TableCell>
      <TableCell colSpan={5} sx={{ bgcolor: COLOR_PICKLE_BLUEWOOD }}>
        Entrata Import Criteria
      </TableCell>
    </TableRow>
    <TableRow sx={{ bgcolor: COLOR_ATHENS_GRAY_DARKER_2 }}>
      <TableCell sx={{ bgcolor: COLOR_LINK_WATER, color: `${COLOR_DOWNRIVER} !important` }}>
        Imported Floor Plan
      </TableCell>
      <TableCell sx={{ bgcolor: COLOR_LINK_WATER, color: `${COLOR_DOWNRIVER} !important` }}>
        Max in a Match Group
      </TableCell>
      <TableCell sx={entrataTableCellSX}>Floor Plan</TableCell>
      <TableCell sx={entrataTableCellSX}>Unit Space</TableCell>
      <TableCell sx={entrataTableCellSX}>Space Option</TableCell>
      <TableCell sx={entrataTableCellSX} align='center'>
        Date Criteria
        <Row>
          Import If
          <DividerVertical />
          During Date Range
        </Row>
      </TableCell>
    </TableRow>
  </TableHead>
);
